<template>
  <v-card>
    <v-card-title>
      <h1>Crear una nueva consulta</h1>
    </v-card-title>
    <v-card-text class="py-0">
      <v-text-field v-model="newThreadData.title" label="Título del mensaje"></v-text-field>
      <v-select
        attach="#imaginary-attachment"
        :menu-props="menuProps"
        v-model="newThreadData.categories"
        :items="categoryList"
        label="Categoría"
        chips
      ></v-select>
      <!-- <v-textarea v-model="newThreadData.message" name="message" label="Mensaje" value="Hola. Estaba interesado en concertar una cita con ustedes."></v-textarea> -->
      <!-- <aru-wysiwyg-editor v-model="newThreadData.message"></aru-wysiwyg-editor> -->
      <custom-editor  this.content v-model="newThreadData.message"  @input="updateMessage"></custom-editor>

    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="secondary" @click.native="$emit('closeForm')">
        Cerrar
      </v-btn>
      <v-btn color="primary" @click="newThread">Enviar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ThreadAPI from '../../services/thread.js';
import AruRouteGuardMixin from '@/mixins/route-guards/AruRouteGuardMixin.js';
// import AruWysiwygEditor from '@/components/commons/form/inputs/AruWysiwygEditor.vue';
import CustomEditor from '@/components/commons/form/inputs/CustomEditor.vue';


export default {
  mixins: [AruRouteGuardMixin],
  components: {
    // AruWysiwygEditor,
    CustomEditor,

  },
  data() {
    return {
      newThreadData: {
        title: '',
        message: '',
        categories: [],
        read_by_customer: true,
      },
      menuProps: {
        // "closeOnClick":true,
        closeOnContentClick: true,
      },
      categoryList: [],
      threadForm: false,
    };
  },
  mounted() {
    this.setCategoryList();
  },
  computed: {
    attachValue() {
      console.log(this.$vuetify.breakpoint.name);
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '#app-layout-container';
        case 'sm':
          return '#app-layout-container';
        case 'md':
          return false;
        case 'lg':
          return false;
        case 'xl':
          return false;
      }

      return false;
    },
    customerCategories() {
      return this.$store.getters.customerCategoriesNames;
    },
  },
  methods: {
    setCategoryList() {
      if (this.userHasAnyRole(['consultant', 'admin', 'superadmin'])) {
        this.categoryList = ['Fiscal', 'Laboral', 'Contable', 'LOPD', 'Otros'];
      } else {
        const sortCat = (a, b) => {
          const order = {
            Fiscal: 0,
            Laboral: 1,
            Contable: 2,
            LOPD: 3,
            Otros: 4,
          };

          return order[a] - order[b];
        };

        if (this.customerCategories && this.customerCategories.length) {
          this.categoryList = this.customerCategories.sort(sortCat);
        } else if (this.userHasAnyRole(['autonomous', 'pyme'])) {
          this.categoryList = ['Fiscal', 'Laboral', 'Contable', 'Otros'];
        }
      }

      if (this.categoryList.length === 1) {
        this.newThreadData.categories = this.categoryList[0];
      }
    },
    newThread() {
      ThreadAPI.postThread(this.newThreadData).then(response => {
        console.log(response);
        this.$emit('created', response.data.data);
        // this.activeThreads.unshift(response.data);
        this.resetNewThreadData();
        this.$emit('created', response.data);
      });
      // axios.post('/thread/vuestore',
      //     this.newThreadData, // the data to post
      //     {} // config
      // ).then(response => {
      //     console.log(response);
      //     this.$emit('created', response.data);
      //     // this.activeThreads.unshift(response.data);
      //     this.resetNewThreadData();
      //     this.threadForm = false;
      // });
      // // console.log(this.newThreadData.categories);
    },
    resetNewThreadData() {
      this.newThreadData = {
        title: '',
        message: '',
        categories: [],
        read_by_customer: true,
      };
    },
    updateMessage(value){
      this.newThreadData.message = value;
    }
  },
};
</script>
